const barLevelCount = 8;
const barCount = 5;
const barMinLevel = 2;
const barMaxLevel = barLevelCount;
const barWavelength = barCount;
export const barFrameMs = 240;
export function barLevels(frame: number): readonly number[] {
  const phase = frame / barWavelength;
  return Array.from({ length: barCount }, (_, i) =>
    Math.round(
      barMinLevel +
        ((barMaxLevel - barMinLevel) *
          (1 + Math.sin(2 * Math.PI * (i / barWavelength - phase)))) /
          2,
    ),
  );
}
export const barLevelsStill = barLevels(0.75);
export function settleLevels({
  from,
  step,
}: Readonly<{
  from: readonly number[];
  step: number;
}>): readonly number[] {
  const remaining = Math.max(0, 2 - step);
  return from.map((level) =>
    Math.max(1, Math.round(1 + (level - 1) * (remaining / 2))),
  );
}
export const barCellW = 3;
const barGutter = 1;
const barMaxHeight = 13;
const barRunW = barCellW * barCount + barGutter * (barCount - 1);
export const badgeColW = barRunW;
export const badgeColH = 15;
const baseline = 13;
export function barX(index: number): number {
  return index * (barCellW + barGutter);
}
export function barHeight(level: number): number {
  return (level / barLevelCount) * barMaxHeight;
}
export function barY(level: number): number {
  return baseline - barHeight(level);
}
export const checkDx = 1;
export const checkPath = "M0 6.9 6.1 13 17 1.5";
export const checkLength = 25;
